import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { getCookie } from '../../shared/utils';
import {
  canShowChatbot,
  resolveChatbotApiRole,
} from '../../services/chatbot/chatbotRoles';
import { ChatWidget } from './ChatWidget';
import './../../ChatbotStyles/ChatWidget.scss';

export const IntegratedChatWidget: React.FC = () => {
  const [authReady, setAuthReady] = useState(false);
  const [accessToken, setAccessToken] = useState<string>('');
  const [customerId, setCustomerId] = useState<string>('');
  const [role, setRole] = useState<string>('');

  const { dashboardUserInfo } = useSelector(
    (state: RootState) => state.dashboardUser,
  );

  useEffect(() => {
    const token = getCookie('access_token') || '';
    const custId = dashboardUserInfo?.customer_id?.toString() || '';
    const userRole = resolveChatbotApiRole(dashboardUserInfo);

    if (canShowChatbot(dashboardUserInfo, token, custId)) {
      setAccessToken(token);
      setCustomerId(custId);
      setRole(userRole);
      setAuthReady(true);
    } else {
      setAuthReady(false);
    }
  }, [dashboardUserInfo]);

  if (!authReady) {
    return null;
  }

  return (
    <ChatWidget
      initialAccessToken={accessToken}
      initialCustomerId={customerId}
      initialRole={role}
    />
  );
};
